var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-card"},[(_vm.showClose)?_c('i',{staticClass:"pp-icon-close-fill pp-card__close",on:{"click":function($event){$event.stopPropagation();return _vm.close.apply(null, arguments)}}}):_vm._e(),_c('div',{staticClass:"pp-card__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }